// extracted by mini-css-extract-plugin
export default {"PdfLink":"styles__PdfLink__kjsZN","Link":"styles__Link__r9M_C","Text":"styles__Text__ry9BV"};